module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/codebuild-2016-10-06.paginators.json
// module id = dNOV
// module chunks = 1